////////////////////////////////////////////////////////////////////////////////
// @copyright Copyright (C) 2020 P. Arentzen <petra@pegu.de>
//
//  This program is free software: you can redistribute it and/or modify
//  it under the terms of the GNU General Public License as published by
//  the Free Software Foundation, either version 3 of the License, or
//  (at your option) any later version.
//
//  This program is distributed in the hope that it will be useful,
//  but WITHOUT ANY WARRANTY; without even the implied warranty of
//  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
//  GNU General Public License for more details.
//
//  You should have received a copy of the GNU General Public License
//  along with this program.  If not, see <https://www.gnu.org/licenses/>.
////////////////////////////////////////////////////////////////////////////////

/**
 *
 * @since 2020-08-08 00:02
 * @author Petra Arentzen
 *
 * @package pegu
 *
 **/

window._matomoTrackingDone = false;

/* tracker methods like "setCustomDimension" should be called before "trackPageView" */
window.matomoDoTracking = function() {
	// noinspection ES6ConvertVarToLetConst
	var _paq = window._paq = window._paq || [];
	// noinspection ES6ConvertVarToLetConst
	// window._matomoTrackingDone = false;

	if (window._matomoTrackingDone) {
		return;
	}
	window._matomoTrackingDone = true;
	_paq.push(['trackPageView']);
	_paq.push(['enableLinkTracking']);
	(function() {
		// noinspection ES6ConvertVarToLetConst,JSUnresolvedVariable
		var u=TYPO3.settings["TS"]["matomo."]["url"];
		_paq.push(['setTrackerUrl', u+'matomo.php']);
		// noinspection JSUnresolvedVariable
		_paq.push(['setSiteId', TYPO3.settings["TS"]["matomo."]["siteId"]]);
		// noinspection ES6ConvertVarToLetConst
		var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
		g.type='text/javascript'; g.async=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);
	})();
}

// noinspection ES6ConvertVarToLetConst,JSUnresolvedVariable
var _cookieConsentCookie = window.cookieconsent.utils.getCookie(TYPO3.settings["TS"]["cookieconsent."]["cookie."]["name"]);

if (_cookieConsentCookie && (_cookieConsentCookie !== window.cookieconsent.status['deny'])) {
	window.matomoDoTracking();
}

